import * as React from 'react';
import { CustomSubmitButton, CustomButton, ButtonType } from "soprasteria-ui-library";
import { useAuth } from '../../../../App';
import { ReferralResponseApi } from "../../../../api/ReferralResponseApi";
import { ReferralAdminApi } from "../../../../api/ReferralAdminApi";
import { IReferralResponseModel } from '../../../../models/IReferral';
import { ReferralCloseModal } from "../ReferralModals/ReferralCloseModal"
import { ReferralCloseWithoutTreatmentsModal } from '../ReferralModals/ReferralCloseWithoutTreatmentsModal';
import { LIBRETTOADMIN } from '../../../../utils/RoleConstants';
import { isInRole, UserContext } from '../../../../contexts/UserContext';

interface IReferralAnswerButtons {
    referralId: number;
    changeSuccessMessage: (message: string) => void;
    changeErrorMessage: (message: string) => void;
    getReferral: (id: number) => void;
    canCloseReferral?: boolean | undefined;
    gotReportedTreatments: boolean;
    isParaply: boolean;
}

export const ReferralAnswerButtons: React.FunctionComponent<IReferralAnswerButtons> = ({ canCloseReferral, referralId, getReferral, changeErrorMessage, changeSuccessMessage, gotReportedTreatments, isParaply }) => {

    const auth = useAuth();
    const manageReferralApi = new ReferralResponseApi(auth);
    const referralAdminApi = new ReferralAdminApi(auth);
    const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);
    const [isAgreementRequired, setIsAgreementRequired] = React.useState<boolean>(false);
    const userInfo = React.useContext(UserContext);
    const hasRoleSystemAdmin = isInRole(LIBRETTOADMIN, userInfo.roles);

    const closeReferral = (data: IReferralResponseModel) => {
        setIsSubmitting(true);
        manageReferralApi.closeReferral(data, () => {
            document.getElementById("close-close-referral-modal")?.click();
            document.getElementById("close-close-referral-modal-no-treatments")?.click();
            getReferral(referralId);
            changeSuccessMessage("Specialistremissen har avslutats");
        }, (error: string) => {
            changeErrorMessage(error);
        }, () => {
            setIsSubmitting(false);
        });
    }

    const closeReferralAsSysAdmin = (data: IReferralResponseModel) => {
        setIsSubmitting(true);
        referralAdminApi.closeReferral(data, () => {
            document.getElementById("close-close-referral-modal")?.click();
            document.getElementById("close-close-referral-modal-no-treatments")?.click();
            getReferral(referralId);
            changeSuccessMessage("Specialistremissen har avslutats");
        }, (error: string) => {
            changeErrorMessage(error);
        }, () => {
            setIsSubmitting(false);
        });
    }

    const openModal = (data: any) => {
        if (gotReportedTreatments || (hasRoleSystemAdmin && canCloseReferral)) {
            document.getElementById("open-close-referral-modal")?.click();
        }
        else {
            document.getElementById("open-close-referral-modal-no-treatments")?.click();
            setIsAgreementRequired(true);
        }
    }

    return (
        <>
            {
                !hasRoleSystemAdmin && canCloseReferral && !isParaply ?
                    <>
                        <CustomSubmitButton onButtonSubmit={openModal} disabled={!canCloseReferral}>Skicka remissvar och avsluta specialistremiss</CustomSubmitButton>
                        <CustomButton buttonType={ButtonType.create} buttonText="" id="open-close-referral-modal" data-toggle="modal" data-target="#close-referral-modal" hidden />
                        <CustomButton buttonType={ButtonType.create} buttonText="" id="open-close-referral-modal-no-treatments" data-target="#close-referral-modal-no-treatments" data-toggle="modal" hidden />
                    </>
                    : null
            }
            {
                hasRoleSystemAdmin && canCloseReferral ?
                    <>
                        <CustomButton buttonType={ButtonType.create} buttonText="" id="open-close-referral-modal" data-toggle="modal" data-target="#close-referral-modal" hidden />
                        <CustomSubmitButton onButtonSubmit={openModal}>Skicka remissvar och avsluta specialistremiss</CustomSubmitButton>
                    </>
                    : null
            }
            {
                gotReportedTreatments || (hasRoleSystemAdmin && canCloseReferral)
                    ? <ReferralCloseModal closeReferralAsSysAdmin={closeReferralAsSysAdmin} closeReferral={closeReferral} canCloseReferralAsSysAdmin={hasRoleSystemAdmin} isSubmitting={isSubmitting} />
                    : <ReferralCloseWithoutTreatmentsModal closeReferralAsSysAdmin={closeReferralAsSysAdmin} closeReferral={closeReferral} canCloseReferralAsSysAdmin={hasRoleSystemAdmin} isSubmitting={isSubmitting} isAgreementRequired={isAgreementRequired} setIsAgreementRequired={setIsAgreementRequired} />
            }
        </>
    )
}